import ClientCombobox from 'components/comboboxes/ClientCombobox';
import MandatoryAsterisk from 'components/common/MandatoryAsterisk';
import MutedText from 'components/common/MutedText';
import HubertCheckbox from 'components/HubertUI/HubertCheckbox';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useTranslation } from 'react-i18next';
import { useCreateTemplateState } from './CreateTemplateContext';

const CreateTemplateDestination = () => {
  const { t } = useTranslation('Templates');
  const { isHubertAdmin, form, accessGroupOptions } = useCreateTemplateState();
  const {
    newTemplate,
    isDestinationRequired,
    isDestinationDisabled,
    canUseSourceClientForDestination,
    shouldShowUseSourceClientToggle,
    onDestinationChange,
    onUseSourceClientForDestinationChange,
    canShareWithOrg,
  } = form;
  const useSourceClientForDestination = newTemplate.useSourceClientForDestination;

  return (
    <>
      <div className="mb-3 text-sm font-semibold text-slate-700">{t('destination.heading')}</div>
      {isHubertAdmin ? (
        <>
          <div className="mb-2 flex flex-wrap items-center justify-between gap-3">
            <HubertLabel htmlFor="create-template-destination-client">
              {t('destination.clientLabel')}
              {isDestinationRequired ? <MandatoryAsterisk /> : null}
            </HubertLabel>
            {shouldShowUseSourceClientToggle ? (
              <label className="flex items-center gap-2 text-sm text-slate-600">
                <HubertCheckbox
                  checked={useSourceClientForDestination}
                  disabled={!canUseSourceClientForDestination}
                  onCheckedChange={(value) => {
                    onUseSourceClientForDestinationChange(Boolean(value));
                  }}
                />
                {t('destination.useSourceClientLabel')}
              </label>
            ) : null}
          </div>
          <ClientCombobox
            id="create-template-destination-client"
            value={newTemplate.destinationClientId}
            onValueChange={(value) => {
              onDestinationChange(value as string);
            }}
            disabled={useSourceClientForDestination || isDestinationDisabled}
          />
          <MutedText className="mt-2 block text-xs font-medium text-slate-500" text={t('destination.clientHint')} />
        </>
      ) : (
        <>
          {canShareWithOrg || accessGroupOptions.length > 0 ? (
            <MutedText text={t('destination.assignedToAccountHint')} />
          ) : (
            <MutedText className="text-danger!" text={t('destination.noAccessGroupError')} />
          )}
        </>
      )}
    </>
  );
};

export default CreateTemplateDestination;
